export default "__VITE_ASSET__chO1m7X2__"